import {
    Button,
    Dropdown,
    InputPlaceholder,
    Message,
    Modal,
    ModalActions,
    ModalContent,
} from '@/platform/ui';
import { Deferred, useForm, usePage } from '@inertiajs/react';

const CreateModal = ({ onClose }) => {
    const { auth, contacts } = usePage().props;
    const { data, setData, post, errors, processing } = useForm({});

    const handleSubmit = () => {
        post(`/customers/${auth.user.selected_customer_id}/datahub-invitees`, {
            onSuccess: () => onClose(),
        });
    };

    return (
        <Modal open={true} onClose={onClose}>
            <ModalContent>
                <Message
                    variant='info'
                    content='Zodra je deze invitee opslaat, versturen we direct een (nieuw) wachtwoordherstel per e-mail.'
                    className='mb-4'
                />
                <Deferred
                    data={['contacts']}
                    fallback={
                        <InputPlaceholder
                            label='Contactpersoon'
                            placeholder='Contactpersonen worden geladen...'
                        />
                    }
                >
                    <Dropdown
                        label='Contactpersoon'
                        value={data?.contact_id || ''}
                        required
                        options={contacts?.map(contact => ({
                            id: contact.id,
                            name: contact.name,
                        }))}
                        onChange={value => setData('contact_id', value)}
                        error={errors?.contact_id}
                    />
                </Deferred>
            </ModalContent>
            <ModalActions>
                <Button
                    variant='primary'
                    onClick={handleSubmit}
                    loading={processing}
                >
                    Opslaan
                </Button>
            </ModalActions>
        </Modal>
    );
};

export default CreateModal;
